module.exports = __webpack_public_path__ + "static/media/far2bus.04b9c83c.png";